<template>
  <!-- click.native.stop が無いと navbar-menu-solutions-panel 内のクリックイベントが吸われる -->
  <b-nav-item-dropdown
    right
    lazy
    class="solution-menu"
    toggle-class="solution-menu-toggle"
    @click.native.stop
    @shown="expanded = true"
    @hidden="expanded = false"
  >
    <template #button-content>
      <div class="solution-menu-bar">
        <img class="solution-menu-image" :src="appIcon" />
        <span class="solution-menu-label">{{ appLabel }}</span>
        <b-icon-chevron-up v-if="expanded" class="solution-menu-toggle-icon"></b-icon-chevron-up>
        <b-icon-chevron-down v-else class="solution-menu-toggle-icon"></b-icon-chevron-down>
      </div>
    </template>
    <template #default>
      <navbar-menu-solutions-panel :app-link-items-ref="solutionLinks" :domain-id="domainId" />
    </template>
  </b-nav-item-dropdown>
</template>

<style lang="scss" scoped>
.solution-menu {
  height: 44px;
  width: 196px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &:focus-visible {
    outline: none;
  }

  .solution-menu-bar {
    flex-grow: 1;

    display: flex;
    gap: 10px;
    justify-content: left;
    align-items: center;
    padding: 0px 6px 0px 6px;

    &:hover {
      background-color: #e9ecef;
      border-radius: 3px;
    }

    .solution-menu-image {
      width: 36px;
      height: 36px;
    }
    .solution-menu-label {
      color: #212529;
    }
    .solution-menu-toggle-icon {
      margin-left: auto;
      margin-right: 0px;
      width: 14px;
      color: #212529;
    }
  }
}
</style>
<style>
/* 標準の下矢印を消す */
.solution-menu > .solution-menu-toggle::after {
  display: none;
}
.solution-menu > .solution-menu-toggle {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 0px 6px 0px 6px;
  flex-grow: 1;
}
/* フォーカス枠を消す */
.solution-menu > .solution-menu-toggle:focus-visible {
  outline: none;
}

/* ソリューションパネルのborder色 */
.solution-menu > .dropdown-menu {
  border-color: #d9d9d9;
}
</style>

<script lang="ts">
import { defineComponent, ref, type PropType } from "vue";
import NavbarMenuSolutionsPanel from "./NavbarMenuSolutionsPanel.vue";
import type { AppLinkItem } from "./types";

export default defineComponent({
  name: "NavBarSolutionButton",
  components: { NavbarMenuSolutionsPanel },
  props: {
    // ソリューションアイコン一覧
    solutionLinks: { type: Array as PropType<AppLinkItem[]>, default: () => [] },
    domainId: { type: String, default: () => "" },
  },
  setup() {
    // 開閉状態の管理
    const expanded = ref(false);

    const appLabel = "掲示板";
    const appIcon = "https://direct4b.app/img/app_icon_forum.svg";

    return { expanded, appLabel, appIcon };
  },
});
</script>
